import React from 'react';
import RecipeListItem from '../recipes/RecipeListItem';
import { Recipe } from '../../api/Recipe';
import { Badge, Box, Flex, ListGroupItem, Skeleton } from '../ui';

interface HomeRecipeListProps {
  recipes: Recipe[];
  showDailySelection: boolean;
  loadingMore: boolean;
  recipesPerPage: number;
  dailySelectionLabel: string;
  favoritePendingIds: string[];
  isFavorite: (recipeId: string) => boolean;
  onFavoriteToggle: (recipe: Recipe) => void;
  lastRecipeElementRef: (node: HTMLElement | null) => void;
}

const HomeRecipeList: React.FC<HomeRecipeListProps> = ({
  recipes,
  showDailySelection,
  loadingMore,
  recipesPerPage,
  dailySelectionLabel,
  favoritePendingIds,
  isFavorite,
  onFavoriteToggle,
  lastRecipeElementRef,
}) => {
  return (
    <>
      {recipes.map((recipe, index) => (
        <Box ref={recipes.length === index + 1 ? lastRecipeElementRef : null} key={recipe.id}>
          {showDailySelection && index === 0 && (
            <Box paddingX={3} paddingTop={3} paddingBottom={2}>
              <Badge variant="warning" pill textBackground>
                {dailySelectionLabel}
              </Badge>
            </Box>
          )}
          <RecipeListItem
            recipe={recipe}
            isFavorite={isFavorite(recipe.id)}
            onFavoriteClick={() => {
              onFavoriteToggle(recipe);
            }}
            favoriteDisabled={favoritePendingIds.includes(recipe.id)}
          />
        </Box>
      ))}
      {loadingMore && (
        <Box role="status" aria-label="Chargement des recettes suivantes">
          {[...Array(recipesPerPage)].map((_, index) => (
            <Flex
              as={ListGroupItem}
              align="center"
              key={`skeleton-list-${index}`}
              shadow="sm"
              rounded
              marginBottom={2}
              padding={2}
              data-testid="recipe-list-item-skeleton"
            >
              <Skeleton
                text={false}
                rounded
                marginEnd={3}
                style={{ width: '60px', height: '60px' }}
              />
              <Skeleton
                text={false}
                style={{ width: '70%', height: '24px' }}
              />
            </Flex>
          ))}
        </Box>
      )}
      <Box style={{ height: '100px', flexShrink: 0 }} aria-hidden="true" />
    </>
  );
};

export default HomeRecipeList;
